import React from "react";
import { Routes, Route } from "react-router-dom";
import routesConfig from "./routesConfig";

interface RouteConfig {
  path: string;
  element?: React.ReactNode;
  component?: React.ComponentType;
  children?: RouteConfig[];
}

const renderRoutes = (routes: RouteConfig[]) => {
  return routes.map((route, index) => {
    const Element = route.component ? route.component : () => route.element;
    return (
      <Route key={index} path={route.path} element={<Element />}>
        {route.children && renderRoutes(route.children)}
      </Route>
    );
  });
};

const AppRoutes: React.FC = () => {
  return <Routes>{renderRoutes(routesConfig)}</Routes>;
};

export default AppRoutes;
